import { memo } from 'react';
import { MdArrowForward } from 'react-icons/md';
import { MobileHomeListData, MobileHomeListItem, MOBILE_HOME_ITEM_TYPES } from '@shared/types/frontend/tables';
import Loading from '@/components/shared/Loading';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';
import NormieCategories from './NormieCategories';
import MobileMemeMode from './MobileMemeMode';
import TopMobileResults from '../TopMobileResults';
import TokenCard from '../TokenCard';
import RecentResults from './RecentResults';
import TodayTopGainers from './TodayTopGainers';
import CashResults from '../CashResult';
import LaunchPadView from '../LaunchPadView';
import { toSpecialFixed } from '@/lib/misc/utils';
import WarningMessage from './WarningMessage';
interface VirtualizedRowProps {
  index: number;
  style: React.CSSProperties;
  data: {
    items: MobileHomeListItem[];
  } & MobileHomeListData;
}
const HomeRow = ({
  index,
  style,
  data: {
    items,
    ...props
  }
}: VirtualizedRowProps) => {
  const item = items[index];
  switch (item.type) {
    /* SHARED */

    case MOBILE_HOME_ITEM_TYPES.LOADING:
      return <div style={style} className={item.data?.className ?? 'w-full flex items-center flex-col justify-center'}>
          <Loading />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TOKEN_RESULT:
      {
        const {
          tokenItem,
          searchResult,
          isTop10,
          isRecentlyListed
        } = item.data;
        const result = <div style={style}>
          {isTop10 ? <TopMobileResults searchResult={searchResult} timeFrame={props.timeFrame} onTokenClick={props.onTokenClick} /> : <TokenCard tokenItem={tokenItem} timeFrame={props.timeFrame} searchResult={searchResult} handleTokenClick={props.handleTokenClick} onTokenClick={props.onTokenClick} mode={props.mode} setAssetModalData={props.setAssetModalData} isRecentlyListed={isRecentlyListed} />}
        </div>;
        return result;
      }

    /* HOME PAGE */

    case MOBILE_HOME_ITEM_TYPES.USER_FUNDS:
      return <div style={style} className='ta-c w-full flex items-center border-b border-genius-blue'>
          {props.isUserWithFunds ? props.isLoadingAssetData ? <Loading /> : <div onClick={() => {
          props.setMobileMode('portfolio');
          //shallow push window
          window.history.pushState({}, '', '/home?m_mode=portfolio');
        }} className='w-full'>
                <div className='ta-l pl-2 w-[95%] rounded-md py-2 flex justify-between items-center'>
                  <div className='flex text-[32px] text-genius-cream'>
                    ${toSpecialFixed(props.assetData.totalUsdValue, 2)?.value}
                  </div>
                  <div>
                    <MdArrowForward className={'w-[20px] h-[20px] text-genius-cream/50 mr-4'} />
                  </div>
                </div>
              </div> : <>
              <Button onClick={() => props.setIsDepositModalOpen(true)} variant='pink' className='w-[90%] m-auto rounded-full h-[56px]'>
                Deposit Cash or Crypto
              </Button>
            </>}
        </div>;
    case MOBILE_HOME_ITEM_TYPES.RECENTLY_LISTED_HEADER:
      return <div style={style}>
          <p className='text-[20px] font-medium text-genius-gradient flex items-center px-4 py-3'>
            New
          </p>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.RECENT_RESULTS:
      return <div style={style} className='flex items-center border-b border-genius-blue '>
          <RecentResults onTokenClick={props.onTokenClick} data={item.data.recentItems} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TOP_GAINERS:
      return <div style={style} className='flex items-center border-y border-genius-blue pb-1'>
          <TodayTopGainers timeFrame={item.data.timeFrame} onTokenClick={props.onTokenClick} subMemeData={item.data.subMemeData} loading={item.data.loading} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TRENDING_TITLE:
      return <div style={style} className='flex justify-between items-center px-4 pt-1'>
          <div className='text-[20px] font-medium text-genius-gradient'>Trending</div>
          <div className='flex items-center gap-2'>
            <Button className={`text-genius-cream text-[14px] rounded-full py-2 h-auto border border-transparent ${props.mode === '' ? 'bg-genius-blue' : 'bg-genius-indigo border-genius-blue'}`} onClick={() => props.setMode('')}>
              Verified
            </Button>
            <Button className={`text-genius-cream text-[14px] rounded-full py-2 h-auto border border-transparent  ${props.mode === 'hot' ? 'bg-genius-blue' : 'bg-genius-indigo border-genius-blue'}`} onClick={() => props.setMode('hot')}>
              Unverified
            </Button>
          </div>
        </div>;

    /* SEARCH MODE */

    case MOBILE_HOME_ITEM_TYPES.SAVED_HEADER:
      return <div style={style}>
          <div className='flex items-center justify-between px-3'>
            <div className='text-genius-cream text-[20px] font-medium'>Saved</div>
            <Button className='bg-genius-blue text-genius-cream text-[14px] rounded-full py-2 h-auto' onClick={props.handleClearSavedTokens}>
              Clear
            </Button>
          </div>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.SAFE_SEARCH:
      return <div style={style} className={`flex justify-between px-4 text-genius-cream items-center py-4 border-genius-blue border-y-[1px] ${props.wildWest && props.mode === 'search' ? 'border-b-transparent' : ''}`}>
          <div className='text-[20px] font-medium'>Safe Search</div>
          <Switch checked={!props.wildWest} onClick={() => {
          props.showWildWest(!props.wildWest);
        }} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.NORMIE_CATEGORIES:
      return <div style={style} className='flex items-center'>
          <NormieCategories setKeyword={props.setKeyword} mode={props.mode} setMode={props.setMode} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.MEME_MODE:
      return <div style={style} className='flex items-start'>
          <MobileMemeMode setMode={props.setMode} subMode={props.subMode} setSubMode={props.setSubMode} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.TOP_10_HEADER:
      return <div style={style} className='flex items-end'>
          <p className='text-genius-gradient text-[16px] font-medium pl-4 ta-l'>Top 10</p>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.ALL_TOKENS_HEADER:
      return <div style={style} className='flex items-end'>
          <p className='text-genius-gradient text-[16px] font-medium pl-4 ta-l'>All Tokens</p>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.LOW_VOLUME_BUTTON:
      return <div style={style} className='flex justify-center items-center'>
          <div className='w-fit bg-genius-blue rounded-full p-2 px-4 text-genius-cream text-[12px]' onClick={() => props.showWildWest(true)}>
            Show Low Volume Results
          </div>
        </div>;
    case MOBILE_HOME_ITEM_TYPES.NO_RESULTS:
      return <div style={style} className='text-genius-cream/50 mx-auto justify-center ta-c text-base flex items-center flex-col'>
          {props.mode === 'search' ? 'No Search Results' : props.mode === 'new' ? 'No New Tokens in the last 24 hours' : 'No Results'}
          {props.mode === 'search' && !props.wildWest && <div className='bg-genius-blue rounded-full p-2 px-4 text-genius-cream mt-4 text-[12px]' onClick={() => props.showWildWest(true)}>
              Show Low Volume Results
            </div>}
        </div>;
    case MOBILE_HOME_ITEM_TYPES.CASH_RESULTS:
      return <div style={style}>
          <CashResults setAssetModalData={props.setAssetModalData} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.LAUNCHPAD:
      return <div style={style}>
          <LaunchPadView />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.UNVERIFIED_WARNING:
      return <div style={style} className='flex items-center px-4'>
          <WarningMessage message='Tokens in this section are algorithmically sourced. We do not take any responsibility for curation. Invest at your own risk.' hideWarning={() => props.setShowUnverifiedWarning(false)} />
        </div>;
    case MOBILE_HOME_ITEM_TYPES.SEARCH_WARNING:
      return <div style={style} className='px-4'>
          <WarningMessage message='Tokens in this section are algorithmically sourced. They include both verified and unverified tokens. Genius is not responsible for scam tokens, honeypots, or malicious actors.' />
        </div>;
    default:
      return null;
  }
};
HomeRow.displayName = 'VirtualizedRow';
export default memo(HomeRow);